import { render, staticRenderFns } from "./rows-editor.vue?vue&type=template&id=66071114&scoped=true"
import script from "./rows-editor.vue?vue&type=script&lang=js"
export * from "./rows-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66071114",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66071114')) {
      api.createRecord('66071114', component.options)
    } else {
      api.reload('66071114', component.options)
    }
    module.hot.accept("./rows-editor.vue?vue&type=template&id=66071114&scoped=true", function () {
      api.rerender('66071114', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/rows-editor.vue"
export default component.exports